export default __webpack_public_path__ + "static/marker-9a7de733774b047806a9040389ad1832.png";